import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useReducer,
  createContext
} from "react";
import { Button, CircularProgress } from '@mui/material';
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlined from "@mui/icons-material/VisibilityOffOutlined";
import PhoneIphoneOutlined from "@mui/icons-material/PhoneIphoneOutlined";
import LockOutlined from "@mui/icons-material/LockOutlined";
import ArrowForward from "@mui/icons-material/ArrowForward";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { TWS } from "../../services/WebServices";
import { RedMedThemeProvider, focusRingSx } from "../../theme/redmedTheme";
import { AuthContext } from "../../providers/AuthStack";

import { db, auth } from "../../services/Firestore";

import {
  collection,
  query,
  where,
  setDoc,
  doc,
  onSnapshot,
  updateDoc
} from "firebase/firestore";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

import getDeviceFingerprint from '../../utils/getDeviceFingerprint';

// Support link under the login button (WhatsApp, contact page…). Set REACT_APP_SUPPORT_URL at build time.
const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL || "";

const OPERATOR_CHIPS = [
  { label: "Mobilis", color: "#22C55E" },
  { label: "Ooredoo", color: "#EF4444" },
  { label: "Djezzy", color: "#F43F5E" },
  { label: "Idoom", color: "#60A5FA" },
];

const labelSx = { display: "block", mb: "8px", fontSize: 14, fontWeight: 700, color: "rm.text" };

const fieldSx = {
  height: 52,
  borderRadius: "12px",
  bgcolor: "rm.surface",
  fontSize: 16,
  fontWeight: 600,
  color: "rm.text",
  "& .MuiOutlinedInput-input": { px: "4px", py: 0, height: "100%" },
  "& .MuiOutlinedInput-input::placeholder": { color: "rm.unavailableText", opacity: 1, fontWeight: 500 },
  "& .MuiInputAdornment-root": { color: "rm.icon" },
  "&.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "error.main" },
};

export default function Login() {
  const [password, setPassword] = useState(null);
  const [phone, setPhone] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const { authDispatch } = useContext(AuthContext);
  const deviceid = Date.now().toString();
  const [isVerified, setisVerified] = useState(true);
  const [otpModal, setotpModal] = useState(false);
  const [final, setfinal] = useState("");
  const [otp, setotp] = useState("");
  const [token, setToken] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loadingbtn, setLoadingbtn] = useState(false);
  const signIn = async () => {
    
    try {
      setLoadingbtn(true)
      await TWS.postLogin(phone, password,).then(res => {
        /*if (!isVerified) {
          setToken(res.token);
          setotpModal(true);
          onSubmit();
        } else {
          
          authDispatch({ type: "SIGN_IN", token: res.token });
          
          FirebaseRegisterDevice(deviceid,res.data.id)
        }*/
       setUserData(res)
       checkfingerPrint(res,fingerprint)
      });
    } catch (errors) {
      //alert("Erreur d'authentification");
      setmsgErrors("Erreur d'authentification, Le numéro de téléphone ou le mot de passe est incorrect");
      setshowErrors(true)
      setLoadingbtn(false)
    }
  };


/**
 *  fingerprint
 */
const [codePin, setCodePin] = useState(null);
const [showcodePinField, setshowcodePinField] = useState(false);

const [fingerprint, setFingerprint] = useState(null);
const fetchFingerprint = async () => {
     const deviceFingerprint = await getDeviceFingerprint();
     setFingerprint(deviceFingerprint);
     //console.log(deviceFingerprint)
     //checkFingerPrint(deviceFingerprint)
 };
 useEffect(() => {
   fetchFingerprint();
 }, []);


function checkfingerPrint(data,fingerprint){
 
 TWS.checkFingerPrint(data.data.id,data.data.token,fingerprint)
     .then(res => {
      
       if(res){
       
        authDispatch({ type: "SIGN_IN", token: data.token });
        FirebaseRegisterDevice(deviceid,data.data.id)
       }else{
        setshowcodePinField(true)
       }
       setLoadingbtn(false)
     })
     .catch(() => {});
} 

function checkPin(){
  setLoadingbtn(true)
  TWS.checkpin(userData.data.id,userData.data.token,codePin,fingerprint)
 
     .then(res => {
      
       if(res){
        authDispatch({ type: "SIGN_IN", token: userData.token });
        FirebaseRegisterDevice(deviceid,userData.data.id)
       }else{
        //alert("Code Pin n'est pas Valide (الرمز غير صحيح)");
        setmsgErrors("Code Pin n'est pas Valide (الرمز غير صحيح)");
        setshowErrors(true)
       }
       setLoadingbtn(false)
     })
     .catch(() => {
      //alert("Code Pin n'est pas Valide (الرمز غير صحيح)");
      setmsgErrors("Code Pin n'est pas Valide (الرمز غير صحيح)");
      setshowErrors(true)
     });
}


  useEffect(() => {
   
    asyncLocalStorage.getItem("deviceId").then(deviceId => {
      if (deviceId == null) {
        asyncLocalStorage.setItem("deviceId", JSON.stringify(deviceid));

        FirebaseInitilaisationRequests();
        FirebaseInitilaisationResponses();
      }
    });
  }, []);

  useEffect(() => {
    asyncLocalStorage.getItem("uid").then(uid => {
      if (uid == null) {
        //setisVerified(false);
        // remove this line later
        asyncLocalStorage.setItem("uid", JSON.stringify("1234ZEDGHYTKKVKFJKDLLLDJ3"));
      }
    });
  }, []);

  const asyncLocalStorage = {
    setItem: function(key, value) {
      return Promise.resolve().then(function() {
        localStorage.setItem(key, value);
      });
    },
    getItem: function(key) {
      return Promise.resolve().then(function() {
        return localStorage.getItem(key);
      });
    }
  };

  const onSubmit = async () => {
    const verify = new RecaptchaVerifier(
      "sign-in-button",
      { size: "invisible" },
      auth
    );

    await signInWithPhoneNumber(auth, "+213" + phone, verify)
      .then(confirmResult => {
        setfinal(confirmResult);
      })
      .catch(error => {
        alert(error.message);
        window.location.reload();
      });
  };
  // Validate OTP
  const ValidateOtp = () => {
    if (otp === null || final === null) return;
    final
      .confirm(otp)
      .then(result => {
        //console.log(result);
        asyncLocalStorage.setItem("uid", JSON.stringify(result.user.uid));
        authDispatch({ type: "SIGN_IN", token: token });
      })
      .catch(err => {
        alert("code n'est pas valide (الرمز غير صحيح)");
      });
  };

  /**
   * update response status to avoid errors
   */

  const FirebaseInitilaisationRequests = async () => {
    try {
      const docref = doc(db, "requests", deviceid);

      await setDoc(docref, {
        status: "false"
      }).then(() => {
        // console.log("inti");
      });
    } catch (errors) {
      //console.log(errors);
    }
  };

  const FirebaseInitilaisationResponses = async () => {
    try {
      const docref = doc(db, "responses", deviceid);

      await setDoc(docref, {
        status: "false"
      }).then(() => {
        // console.log("inti");
      });
    } catch (errors) {
      //console.log(errors);
    }
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handlePhoneChange = event => {
    setPhone(event.target.value);
  };



// register the user device

  const FirebaseRegisterDevice = async (device_id,user_id) => {
 
    try {
    const docref = doc(db, "userdevices", device_id);

      await setDoc(docref, {
         user :user_id,
        device: navigator.userAgent,
      }).then(() => {
       
      });
    } catch (errors) {
     // console.log(errors);
    }
  }

  // handelerror
  const [showErrors, setshowErrors] = useState(false);
  const [msgErrors, setmsgErrors] = useState('');

  const handelErrorDialog = () => {
    setmsgErrors('')
    setshowErrors(!showErrors)
  };

  // Real <form> submit so Enter works; same branching as the old button onClick.
  const onFormSubmit = event => {
    event.preventDefault();
    if (loadingbtn) return; // Prevent multiple clicks while loading
    if (showcodePinField) {
      checkPin()
    } else {
      signIn();
    }
  };

  const credentialsInvalid = showErrors && !showcodePinField;
  const pinInvalid = showErrors && showcodePinField;

  return (
    <RedMedThemeProvider>
      <CssBaseline />
      <Box
        component="main"
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexWrap: "wrap",
          alignContent: { xs: "flex-start", md: "stretch" },
          bgcolor: "rm.page",
        }}
      >
        {/* Brand panel */}
        <Box
          component="section"
          aria-label="RedMed Telecom"
          sx={{
            flex: "1 1 420px",
            bgcolor: "rm.dark",
            color: "rm.onDark",
            p: { xs: 3, md: 6 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: { xs: 3, md: 6 },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <Box
              aria-hidden="true"
              sx={{
                width: 44,
                height: 44,
                borderRadius: "13px",
                bgcolor: "primary.main",
                display: "grid",
                placeItems: "center",
                fontSize: 16,
                fontWeight: 800,
              }}
            >
              RM
            </Box>
            <Box sx={{ fontSize: 20, fontWeight: 800, letterSpacing: "-0.01em" }}>RedMed Telecom</Box>
          </Box>

          <Box sx={{ maxWidth: 440 }}>
            <Box
              component="p"
              sx={{ m: 0, fontSize: { xs: 26, md: 36 }, fontWeight: 800, lineHeight: 1.15, letterSpacing: "-0.03em" }}
            >
              Toutes vos recharges, au même endroit.
            </Box>
            <Box component="p" sx={{ mt: 2, mb: 0, fontSize: { xs: 14, md: 16 }, lineHeight: 1.55, color: "rm.onDarkMuted" }}>
              Flexy Mobilis, Ooredoo et Djezzy, Idoom ADSL et 4G, cartes de recharge et suivi de vos clients.
            </Box>
            <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0, mt: 2.5, display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {OPERATOR_CHIPS.map(chip => (
                <Box
                  component="li"
                  key={chip.label}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    height: 32,
                    px: "12px",
                    borderRadius: "999px",
                    bgcolor: "rm.darkRaised",
                    fontSize: 13,
                    fontWeight: 700,
                  }}
                >
                  <Box aria-hidden="true" sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: chip.color }} />
                  {chip.label}
                </Box>
              ))}
            </Box>
          </Box>

          <Box sx={{ fontSize: 13, color: "#A39CC0" }}>© RedMed {new Date().getFullYear()}</Box>
        </Box>

        {/* Form area */}
        <Box
          sx={{
            flex: "999 1 460px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 2, sm: 3 },
            py: { xs: 4, md: 6 },
          }}
        >
          <Box
            component="form"
            noValidate
            onSubmit={onFormSubmit}
            sx={{ width: "100%", maxWidth: 400, display: "flex", flexDirection: "column", gap: "22px" }}
          >
            <Box>
              <Box component="h1" sx={{ m: 0, fontSize: 30, fontWeight: 800, letterSpacing: "-0.02em", color: "rm.text" }}>
                Connexion
              </Box>
              <Box component="p" sx={{ mt: "6px", mb: 0, fontSize: 15, color: "rm.textSecondary" }}>
                Accédez à votre espace RedMed.
              </Box>
            </Box>

            <Box>
              <Box component="label" htmlFor="phone" sx={labelSx}>
                Téléphone
              </Box>
              <OutlinedInput
                id="phone"
                name="phone"
                type="tel"
                required
                fullWidth
                autoFocus
                autoComplete="username"
                placeholder="06 XX XX XX XX"
                inputProps={{ inputMode: "numeric", "aria-invalid": credentialsInvalid }}
                error={credentialsInvalid}
                sx={fieldSx}
                startAdornment={
                  <InputAdornment position="start">
                    <PhoneIphoneOutlined fontSize="small" />
                  </InputAdornment>
                }
                onChange={event => {
                  setPhone(event.target.value);
                }}
              />
            </Box>

            <Box>
              <Box component="label" htmlFor="outlined-adornment-password" sx={labelSx}>
                Mot de passe
              </Box>
              <OutlinedInput
                id="outlined-adornment-password"
                name="password"
                required
                fullWidth
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                inputProps={{ "aria-invalid": credentialsInvalid }}
                error={credentialsInvalid}
                sx={{ ...fieldSx, pr: "6px" }}
                onChange={event => {
                  setPassword(event.target.value);
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <LockOutlined fontSize="small" />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Afficher le mot de passe"
                      aria-pressed={showPassword}
                      onClick={handleClickShowPassword}
                      sx={{ width: 40, height: 40, color: "rm.icon", ...focusRingSx }}
                    >
                      {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </Box>

            {showcodePinField && (
              <Box>
                <Box component="label" htmlFor="pin" sx={labelSx}>
                  Code PIN
                </Box>
                <OutlinedInput
                  id="pin"
                  name="pin"
                  required
                  fullWidth
                  autoFocus
                  autoComplete="one-time-code"
                  inputProps={{ inputMode: "numeric", "aria-invalid": pinInvalid, "aria-describedby": "pin-help" }}
                  error={pinInvalid}
                  sx={fieldSx}
                  onChange={event => {
                    setCodePin(event.target.value);
                  }}
                />
                <Box id="pin-help" sx={{ mt: "8px", fontSize: 13, fontWeight: 600, color: "rm.textSecondary" }}>
                  Veuillez introduire le code Pin
                </Box>
              </Box>
            )}

            {showErrors && msgErrors && (
              <Alert severity="error" onClose={handelErrorDialog} sx={{ borderRadius: "12px", fontSize: 14 }}>
                {msgErrors}
              </Alert>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              id="sign-in-button"
              disabled={loadingbtn}
              aria-busy={loadingbtn}
              sx={{
                "&&": { height: 52, borderRadius: "12px", fontSize: 16, fontWeight: 800 },
                ...focusRingSx,
              }}
            >
              {loadingbtn ? (
                <>
                  <CircularProgress size={18} color="inherit" aria-hidden="true" />
                  Connexion…
                </>
              ) : (
                <>
                  Se connecter
                  <ArrowForward fontSize="small" aria-hidden="true" />
                </>
              )}
            </Button>

            <Box component="p" sx={{ m: 0, textAlign: "center", fontSize: 13, color: "rm.textSecondary" }}>
              Pas encore de compte ou problème d'accès ?{" "}
              {SUPPORT_URL ? (
                <Box
                  component="a"
                  href={SUPPORT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontWeight: 700,
                    color: "primary.main",
                    textDecoration: "none",
                    borderRadius: "4px",
                    "&:hover": { textDecoration: "underline", color: "primary.main" },
                    "&:focus-visible": { outline: "2px solid", outlineColor: "primary.main", outlineOffset: "2px" },
                  }}
                >
                  Contactez RedMed
                </Box>
              ) : (
                <Box component="strong" sx={{ fontWeight: 700, color: "primary.main" }}>Contactez RedMed</Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      <Dialog open={otpModal}>
        <DialogTitle>Compte vérification</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Entrez le code envoyé à votre numéro
          </DialogContentText>
          <DialogContentText>
            يرجى ادخال رمز التحقق الذي تم ارساله الى رقم هاتفك
          </DialogContentText>
          <TextField
            margin="normal"
            required
            fullWidth
            id="code"
            label="Code"
            name="code"
            autoComplete="code"
            autoFocus
            onChange={event => {
              setotp(event.target.value);
            }}
          />
          <Box
            sx={{
              width: 300
            }}
          >
            <div id="recaptcha-container"></div>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            fullWidth
            variant="contained"
            sx={{ mb: 2, height: 40, borderRadius: 20 }}
            className="main_btn"
            onClick={() => {
              ValidateOtp();
            }}
          >
            Vérification
          </Button>
        </DialogActions>
      </Dialog>
    </RedMedThemeProvider>
  );
}
